import {URL_API} from "../../../url.config";
import {request} from "../../../utils/apiUtils";
let NewsController = {
    search: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/news/search`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/news/create`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    edit: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/news/edit`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    detail: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/news/detail/?id=${id}`,
            method: 'GET'
        }, callback)
    },
    delete: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/news/delete/?id=${id}`,
            method: 'GET'
        }, callback)
    }
}
export default NewsController
